type RuntimeEnv = Record<string, string | boolean | undefined>;

export function getRuntimeEnv(): RuntimeEnv {
  const viteEnv = ((import.meta as ImportMeta & { env?: RuntimeEnv }).env ?? {}) as RuntimeEnv;
  if (Object.keys(viteEnv).some((key) => key.startsWith('VITE_'))) return viteEnv;
  const nodeEnv = (globalThis as { process?: { env?: RuntimeEnv } }).process?.env;
  return nodeEnv ?? viteEnv;
}
